import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { ActionsService } from '@modules/search/services/actions.service';
import { DocViewerComponent } from '../doc-viewer/doc-viewer.component';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { EmailInfoComponent } from '../../../../shared/components/email-info/email-info.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommentsComponent } from '../comments/comments.component';
import { SummarizeChatComponent } from '../../../../shared/components/summarize-chat/summarize-chat.component';
import { ProjectService } from '@core/services/project/project.service';
import { ExtractionsService } from '@modules/extractions/extractions.service';
import { ExtractionDetailComponent } from '../../../../../extractions/components/extraction-detail/extraction-detail.component';
import { SplitterModule } from 'primeng/splitter';

@Component({
  selector: 'app-doc-container',
  standalone: true,
  imports: [
    ToolbarComponent,
    DocViewerComponent,
    ConfirmPopupModule,
    EmailInfoComponent,
    CommentsComponent,
    SummarizeChatComponent,
    ExtractionDetailComponent,
    SplitterModule,
  ],
  providers: [ConfirmationService],
  templateUrl: './doc-container.component.html',
  styleUrl: './doc-container.component.scss',
})
export class DocContainerComponent implements OnChanges {
  @Input() data: any;
  @Input() isNewTab: boolean = false;
  docTitle!: string;
  docType!: string;
  toolbar: any[] = [];
  fileData: any;
  constructor(
    protected _action: ActionsService,
    private confirmationService: ConfirmationService,
    protected _project: ProjectService,
    protected _extraction: ExtractionsService,
    private message: MessageService
  ) {}

  @ViewChild('docViewBody', { static: true }) docViewBody: any;
  docViewBodyHeight: string = '100%';

  ngOnChanges(): void {
    if (this.data && this.data._source) {
      if (
        this.data &&
        this.data._source &&
        this.data._source.MD5 &&
        this._project.currentProject().isSearchShowExtractions
      ) {
        this._extraction.getExtractionByMD5(this.data._source.MD5);
      }
      this.fileData = null;
      setTimeout(() => {
        this.fileData = this.data;
      }, 10);
      this.docType = this.data._source.fileType;
      this.docTitle = this.data._source.filePath.split('/').pop();
      this.manageToolbar(this.data);
    }
  }

  winNum: number = 0;

  manageToolbar = (data: any) => {
    this.toolbar = [
      {
        label: 'Download',
        icon: 'pi pi-download',
        iconStyle: 'font-size: 0.9rem !important',
        isHidden: !this._project.currentProject().isAllowDownload,
        command: () => {
          this._action.downloadFile(data);
        },
      },
      {
        label: 'Share Document',
        icon: 'pi pi-share-alt',
        isHidden: this.isNewTab,
        command: () => {
          this._action.shareDocument(data);
        },
      },
      {
        label: 'Comments',
        icon: 'pi pi-comments',
        isHidden: false,
        badgeValue: this.data._source.comments
          ? this.data._source.comments.length
          : 0,
        command: () => {
          setTimeout(() => {
            const element = document.getElementById('comment-section');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }, 100);
        },
      },
      {
        label: 'Manage Labels',
        icon: 'pi pi-tags',
        iconStyle: 'font-size: 1.1rem !important',
        isHidden: this.isNewTab,
        command: () => {
          this._action.manageLabels(this.data, 'search');
        },
      },
      {
        label: 'Extracted Entities',
        icon: 'svg-extraction',
        isHidden: !this._project.currentProject().isSearchShowExtractions,
        command: () => {
          if (!this._extraction.selectedExtractionForSearch._id) {
            this.message.add({
              severity: 'warn',
              summary: 'No Extraction Found',
              detail: 'Please try again later',
              key: 'tr',
            });
            return;
          }
          this.docViewBodyHeight =
            this.docViewBody.nativeElement.scrollHeight - 150 + 'px';
          this._action.isShowExtractedEntity =
            !this._action.isShowExtractedEntity;
        },
      },
      {
        label: 'Info',
        icon: 'pi pi-info-circle',
        iconStyle: 'font-size: 1.1rem !important',
        isHidden: false,
        command: () => {},
      },
      {
        label: 'Open in new window',
        icon: 'pi pi-external-link',
        isHidden: this.isNewTab,
        iconStyle: 'font-size: 0.9rem !important',
        command: () => {
          localStorage.setItem('newTabData', JSON.stringify(this.data));
          localStorage.setItem(
            'currentProject',
            JSON.stringify(this._project.currentProject())
          );
          let win = 'tab' + this.winNum;
          this.winNum++;
          window.open('/document', '_blank');
        },
      },
    ];
  };
  openDocInfo(element: any) {
    this.confirmationService.confirm({
      target: element.el.nativeElement as EventTarget,
      key: 'docInfoPopup',
    });
  }

  closeExtractionDetails() {
    this._extraction.isEditEntities = false;
    this._action.isShowExtractedEntity = false;
  }
}
